import { render } from "./NicsTable.vue?vue&type=template&id=cd0c4f8c"
import script from "./NicsTable.vue?vue&type=script&lang=js"
export * from "./NicsTable.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__